import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import CookieConsentBanner from 'main/components/CookieConsentBanner';
import Docs from 'pages/Landings/Docs';

const App: React.FC = () => {
    return (
        <>
            <Switch>
                <Route exact path={['/', '/changelog', '/changelog/:id']} component={Docs} />
                <Route path="*" render={() => <Redirect to="/" />} />
            </Switch>
            <CookieConsentBanner />
        </>
    );
};

export default App;
